import React, { useEffect } from "react";

export default function Page({ className='', children }) {
  const body = document.getElementsByTagName('body')[0];

  useEffect( function() {
    body.classList.add(className);

    return () => body.classList.remove(className);
  }, [className, body.classList] );

  return <>
    {children}
  </>;
}
